export default "__VITE_ASSET__FZbXQgWf__"